import { render, staticRenderFns } from "./CreateEditDataCenter.vue?vue&type=template&id=73f96f06&scoped=true&"
import script from "./CreateEditDataCenter.vue?vue&type=script&lang=ts&"
export * from "./CreateEditDataCenter.vue?vue&type=script&lang=ts&"
import style0 from "./CreateEditDataCenter.vue?vue&type=style&index=0&id=73f96f06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f96f06",
  null
  
)

export default component.exports